import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {

	isMqyStation: false,

	/*PWA 신청현황 시작*/
	searchParams: SEARCH_PARAMS(),
	pwaApcnList: [],
	prcsStepList: [], //조회조건 처리단계
	prcsRsltList: [], //조회조건 처리결과
	pwaDdList: [], //조회조건 날자선택값
	gridPrcStepList: [], //그리드안에 사용여부
	pagingInfo: PAGING_INFO(),
	/*PWA 신청현황 끝*/

	/*PWA 신청현황 팝업관련 state 시작*/
	pwaApcnPopUp: PWA_APCN_POPUP(), //PWA신청 팝업조회
	savePwaApcn: PWA_APCN_POPUP(), //PWA신청 저장State
	pwaApcnSwapPartsList: [], //PWA신청팝업 교환부품정보
	apprCommentList: [], //PWA신청팝업 심의평론목록
	otherFeeList: [], //PWA신청팝업 기타비용명세
	fileList: [], //파일첨부 디테일 조회할때
	occuRegnListPop: [], //PWA신청팝업 PWA기초 정보 발생지역
	causCdListPop: [], //PWA신청현황 PWA기초 정보 원인코드
	ctypeList: [], //PWA신청현황 PWA기초 정보 Ctype
	isSaveFlag: false,
	prcStateCd: '',
	feeTypeOptions: [],
	tmpCustSaleDd: '', //임시 고객판매일자
	tmpDgnDd: '', //임시 진단일자.
	/*PWA 신청현황 팝업관련 state 끝*/

	popupSearchParams: POPUP_SEARCH_PARAMS()
};

function PWA_APCN_POPUP() {
	return {
		pwaNo: '', //PWA번호
		prcsStepNm: '', //처리단계명
		prcStep: '', //처리단계
		aplcDd: '', //신청일
		dcsnDd: '', //확정일
		carVin: '', //VIN no
		pmcNo: '', //PMC no
		pmcId: '', //PMC id
		vehlNm: '', //차종
		jvSaleDd: '', //HTWO판매일
		custNm: '', //판매사
		oemSaleDd: '', //고객사 판매일
		saleRegnNm: '', //판매지역
		flclSpcNm: '', //연료전지사양
		grntPlcy: '', //보증정책
		dlrCpnyCd: '', //딜러점코드
		dlrCpnyNm: '', //딜러점명
		rprRegn: '', //수리지역
		occuRegn: '', //발생지역
		dtlRegn: '', //지역세부
		causPartNo: '', //원인부품
		causPartNm: '', //원인부품명
		carTypeNm: '', //차종유형
		usePrd: '', //사용기간
		milg: '', //주행거리
		wrntStrtDd: '', //품질보증 시작일
		wrntEndDd: '', //보증만료일
		dgnDd: '', //진단일자
		causCd: '', //원인코드
		phmnCd: '', //현상코드
		phmnNm: '', //현상코드명
		ctype: '', //ctypeCd
		dtc1: '', //dtc1
		dtc2: '', //dtc2
		dtc3: '', //dtc3
		prtlSbc: '', //특이사항
		usePrdPo: '', //보증사용기간
		milgPo: '', //보증주행거리
		prcsRslt: '', //처리결과,
		fileId: '', //파일Id
		btnTsAuth: false, // 임시저장버튼권한
		btnApAuth: false, //신청버튼권한
		btnDelAuth: false, //삭제버튼권한
		btnApprAuth: false, //승인,반려,기각버튼권한
		btnApprAuth2: false, //승인버튼권한
		readOnlyAuth: false, //리드온리구분값 신청일경우 입력못하게 함.
		dlrCpnyReadOnlyAuth: false, //리드온리구분값 신청일경우 입력못하게 함.
		backBtnOnlyAuth: false,
		fileList: [], //파일첨부
		delFileList: [],
		eMailtitle: '',
		eMailContents: '',
		mtrlCst: '',
		wags: '',
		incdCst: '',
		totPartCst: '',
		selUsedYear: '', //PMCID에서 선택할때 진단일자와 OEM판매일을 가지고 조회해서 사용기간년을 가져옴
		aplcId: '', //신청자Id
		aplcNm: '', //신청자name
		licensePlate: '', //차량번호판
		nonWarrantyFee: '', //비보증총금액
		dlrCpnyFee: '', //서비스스테이션비용
		warrantyFee: '', //보증총금액
		otherFeeList: [],
		apprCommentList: []
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*딜러점*/,
		carVin: '' /*차량VIN*/,
		prcStepGb: '' /*처리단계*/,
		prcRsltCd: '' /*처리결과*/,
		prcPwaDd: '' /* 검색날짜구분값*/,
		startAplcDd: startDt /*일자초기값from*/,
		endAplcDd: endDt /*일자초기값to*/,
		pmcId: '',
		pwaStartDt: '',
		pwaEndDt: '',
		aplcNm: '',
		pwaNo: ''
	};
}
function POPUP_SEARCH_PARAMS() {
	return {
		dlrCpnyCd: '' /*딜러점*/,
		carVin: '' /*차량VIN*/,
		pwaNo: '' /*PWA번호*/,
		prcsRslt: '10' /*처리결과*/
	};
}

export { SEARCH_PARAMS, PWA_APCN_POPUP, PAGING_INFO, POPUP_SEARCH_PARAMS };
